import PropTypes from "prop-types"
import "./PrimeNote.scss"

// icons

// Note: Uncomment when success and error types are needed
import {
  WarningOutlined,
  InfoCircleOutlined,
  // CheckCircleOutlined,
  // CloseCircleOutlined
} from "@ant-design/icons"

const PrimeNote = ({
  type = "info",
  align = "flex-start",
  msg,
  className,
  style = {},
  disabledIcon = false,
  iconSize = "lg",
  fontSize = "md",
  fontStyle = "italic",
}) => {
  let classNames = [`prime-note-container ${align}`]
  if (className) classNames.push(className)

  // type
  switch (type) {
    case "warning":
      classNames.push("warning-note")
      break

    case "info":
      classNames.push("info-note")
      break

    // Note: Uncomment when success and error types are needed
    // case "success":
    //   classNames.push("success-note")
    //   break

    // case "error":
    //   classNames.push("error-note")
    //   break

    default:
      classNames.push("info-note")
      break
  }

  // Font Size
  if (fontSize === "sm") {
    classNames.push("note-sm")
  } else if (fontSize === "lg") {
    classNames.push("note-lg")
  } else {
    classNames.push("note-md")
  }

  // Font Style
  if (fontStyle === "italic") {
    classNames.push("note-italic")
  } else if (fontStyle === "normal") {
    classNames.push("note-normal")
  }

  // Icon size
  if (iconSize === "sm") {
    classNames.push("icon-sm")
  }

  if (iconSize === "lg") {
    classNames.push("icon-lg")
  }

  // For type: 'error', 'info', 'success', 'warning'
  const renderIcon = () => {
    switch (type) {
      case "info":
        return <InfoCircleOutlined className="note-icon" />
      case "warning":
        return <WarningOutlined className="note-icon" />

      // Note: Uncomment when success and warning types are needed
      // case "success":
      //   return <CheckCircleOutlined className="note-icon" />
      // case "error":
      //   return <CloseCircleOutlined className="note-icon" />

      default:
        return <InfoCircleOutlined className="note-icon" />
    }
  }

  return (
    <div
      className={classNames.join(" ")}
      style={style}
    >
      {!disabledIcon && renderIcon()}
      <p className="note-msg">{msg}</p>
    </div>
  )
}

export default PrimeNote

// PrimeNote: Add "error" and "success" as possible values for the type prop.
PrimeNote.propTypes = {
  type: PropTypes.oneOf(["info", "warning"]),
  msg: PropTypes.string | PropTypes.ReactNode,
  style: PropTypes.object,
  className: PropTypes.string,
  disabledIcon: PropTypes.bool,
  iconSize: PropTypes.oneOf(["sm", "md", "lg"]),
  fontSize: PropTypes.oneOf(["sm", "md", "lg"]),
  fontStyle: PropTypes.oneOf(["italic", "normal"]),
}
